import { EventIds } from 'constants/eventIds';
import { useEffect } from 'react';
import { ApolloError } from '@apollo/client';
import { log } from 'utils/log';
import { ErrorBoundaryVariant } from 'types/errorBoundaryVariant';
import { useErrorBoundaryContext } from 'contexts/ErrorBoundaryContext/ErrorBoundaryContext';

export const itemErrorGuard =
    <T>(loading: boolean, error?: ApolloError, item?: T) =>
    () =>
        Boolean(error || (!loading && !item));

const useUpdateErrorBoundary = ({
    message,
    eventId,
    variant = 'page',
    getDidError,
    error,
}: {
    message: string;
    eventId: EventIds;
    variant?: ErrorBoundaryVariant;
    getDidError: () => boolean;
    error?: ApolloError;
}): boolean => {
    const { setError } = useErrorBoundaryContext();
    const didError = getDidError();

    useEffect(() => {
        if (didError) {
            const extensions = error?.graphQLErrors[0]?.extensions;
            const status = (
                extensions?.exception as {
                    status?: number;
                }
            )?.status;

            if (error) {
                log.error(message, eventId, error, { status });
            } else {
                log.error(message, eventId);
            }

            setError({
                variant,
                status,
            });
        }
    }, [didError, eventId, message, setError, variant, error]);

    return didError;
};

export default useUpdateErrorBoundary;
